<template>
  <div class="container page withdraw-page">
    <van-nav-bar :title="$t('withdraw.with_center') || 'Withdraw'" class="custom-nav" :border="false">
      <template #left>
        <van-icon name="arrow-left" color="#e6b98a" size="24" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main-content">
      <!-- 余额背景横幅 -->
      <div class="balance-banner">
        <div class="balance-content">
          <span class="balance-val">${{ this.userInfo.money || '0.00' }}</span>
          <span class="balance-label">{{$t("my.balance")}}</span>
        </div>
      </div>

      <!-- 提现表单卡片 -->
      <div class="form-card">


        <!-- 银行卡选择 -->
        <div class="bank-row" v-if="bankInfo.bankid">
          <!--<van-icon name="card" class="bank-icon" />-->
          <div class="bank-detail">
            <span class="bank-name">USDT:{{bankInfo.bankid}}</span>
            <!--<span class="bank-num">{{bankInfo.fhnumber}}</span>-->
          </div>
          <van-icon name="checked" class="check-icon" />
        </div>

        <!-- 输入金额 -->
        <div class="input-area">
          <span class="currency-symbol">$</span>
          <input 
            type="number" 
            v-model="withdraw_money" 
            class="money-input" 
            :placeholder="$t('q14') || 'Withdraw Amount'"
          />
        </div>

        <!-- 输入密码 -->
        <div class="input-area">
          <van-icon name="lock" class="currency-symbol icon-lock" />
          <input 
            type="password" 
            v-model="paypassword" 
            class="money-input" 
            :placeholder="$t('q15') || 'Payment Password'"
          />
        </div>

        <!-- 确认按钮 -->
        <button class="confirm-btn" @click="doWithdraw()">
          {{$t('q18') || 'Withdraw Now'}}
        </button>
      </div>

      <!-- 规则说明 -->
      <div class="shuoming">
        <div class="l_p q1"><van-icon name="info-o" /> {{$t('q19') || 'Rules'}}：</div>
        <div class="l_p">1、{{$t('q20') || 'Max'}}{{ getCurrentLevelWithdrawMax() }}{{$t("reservation.ge") || ''}}</div>
        <div class="l_p">2、{{$t('q21') || 'Min'}}{{ getCurrentLevelWithdrawMin() }}{{$t("reservation.ge") || ''}}</div>
        <div class="l_p">3、{{$t('q22')}}</div>
        <div class="l_p">4、{{$t('q23')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      money:"",
      paypassword:"",
      showPopover: false,
      withdraw_money:"",
      userInfo:{},
      withdrawRole:{},
      bankInfo:{},
      currentLevel: null
    };
  },
  methods: {
    // 获取当前用户等级信息
    getCurrentLevel() {
      if (!this.userInfo.all_levels || !this.userInfo.vip) return null;
      return this.userInfo.all_levels.find(level => level.name === this.userInfo.vip);
    },

    // 获取当前等级最大提现金额
    getCurrentLevelWithdrawMax() {
      const level = this.getCurrentLevel();
      return level ? level.withdraw_max_amount : this.withdrawRole.max;
    },

    // 获取当前等级最小提现金额
    getCurrentLevelWithdrawMin() {
      const level = this.getCurrentLevel();
      return level ? level.withdraw_min_amount : this.withdrawRole.min;
    },

    // 获取当前等级最小完成单数
    getCurrentLevelMinCompletedOrders() {
      const level = this.getCurrentLevel();
      return level ? level.min_completed_orders : 0;
    },

    // 获取当前等级提现手续费
    getCurrentLevelWithdrawFee() {
      const level = this.getCurrentLevel();
      return level ? level.withdraw_fee : '0';
    },

    // 获取当前等级提现次数
    getCurrentLevelWithdrawCount() {
      const level = this.getCurrentLevel();
      return level ? level.withdraw_count : 0;
    },

    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        
        if(res.code === 200){
          this.bankInfo = res.data.info || {};
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    back(){
      return window.history.back();
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
          console.log('用户信息:', this.userInfo);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res=>{
        if(res.code === 200){
          console.log(res.data,"res.data---119")
          this.withdrawRole = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    allMoeny(){
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw(){
      if(!this.paypassword){
        this.$toast(this.$t('q24'));
        return false;
      }
      
      if(!this.withdraw_money || this.withdraw_money <= 0){
        this.$toast(this.$t("setting.correct_money"));
        return false;
      }

      // 验证提现条件
      const amount = parseFloat(this.withdraw_money);
      const minAmount = parseFloat(this.getCurrentLevelWithdrawMin());
      const maxAmount = parseFloat(this.getCurrentLevelWithdrawMax());
      const balance = parseFloat(this.userInfo.money);
      const todayCompleted = this.userInfo.daily_order_limit ? this.userInfo.daily_order_limit.today_completed : 0;
      const minCompletedOrders = this.getCurrentLevelMinCompletedOrders();
		
      if (amount < minAmount) {
        this.$toast(`${this.$t('withdraw.min_amount_error')} ${minAmount}`);
        return false;
      }
	
      if (amount > maxAmount) {
        this.$toast(`${this.$t('withdraw.max_amount_error')} ${maxAmount}`);
        return false;
      }

      if (amount > balance) {
        this.$toast(this.$t('withdraw.insufficient_balance'));
        return false;
      }

      if (todayCompleted < minCompletedOrders) {
        this.$toast(`${this.$t('withdraw.min_orders_error')} ${minCompletedOrders}`);
        return false;
      }

      this.$http({
        method: 'post',
        data:{money:this.withdraw_money,paypassword:this.paypassword},
        url: 'user_set_withdraw'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          this.getUserInfo();
          this.getUserWithdrawRole();
          this.withdraw_money = '';
          this.paypassword = '';
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    withdrawInfo(){
      this.showPopover = true;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  },
  mounted(){
    this.getUserBankInfo();
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.withdraw-page {
  background-color: #1f1c1f;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 导航栏暗金风格 */
.custom-nav {
  background-color: #1f1c1f !important;
  position: relative;
  z-index: 10;
}
::v-deep .custom-nav .van-nav-bar__title {
  color: #e6b98a !important;
  font-size: 36px;
}
::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0 !important;
}

/* Balance Banner */
.balance-banner {
  background: linear-gradient(to right, #e2bb91, #d4a572);
  height: 240px;
  padding: 40px 60px 0;
  box-sizing: border-box;
}

.balance-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
  
  .balance-val {
    font-size: 40px;
    font-weight: bold;
  }
  
  .balance-label {
    font-size: 36px;
    font-weight: bold;
  }
}

/* Main Content */
.main-content {
  flex: 1;
}

.form-card {
  background-color: #212025;
  border-radius: 40px 40px 0 0;
  margin-top: -60px;
  padding: 60px 40px 40px;
  position: relative;
  z-index: 5;
  min-height: 500px;
}

/* 账户信息 */
.user-info-row {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  color: #e6b98a;
  font-size: 32px;
  background: #2b2b2b;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid #3a3a3a;
  
  .icon {
    font-size: 40px;
    margin-right: 16px;
  }
  .label {
    margin-right: 16px;
    color: #999;
  }
  .value {
    font-weight: bold;
    color: #fff;
  }
}

/* 银行卡选择 */
.bank-row {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #4a3c31, #2b2b2b);
  border: 2px solid #766350;
  border-radius: 16px;
  padding: 30px 24px;
  margin-bottom: 40px;
  
  .bank-icon {
    font-size: 48px;
    color: #e6b98a;
    margin-right: 20px;
  }
  
  .bank-detail {
    flex: 1;
    display: flex;
    flex-direction: column;
    
    .bank-name {
      color: #fff;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 8px;
    }
    .bank-num {
      color: #999;
      font-size: 28px;
      font-family: monospace;
    }
  }
  
  .check-icon {
    font-size: 40px;
    color: #07c160;
  }
}

/* Input Area */
.input-area {
  display: flex;
  align-items: center;
  border-bottom: 2px solid #333;
  padding-bottom: 20px;
  margin-bottom: 40px;
  
  .currency-symbol {
    color: #df9452;
    font-size: 48px;
    margin-right: 20px;
    font-weight: 500;
    
    &.icon-lock {
      font-size: 40px;
    }
  }
  
  .money-input {
    flex: 1;
    background: transparent;
    border: none;
    color: #fff;
    font-size: 40px;
    outline: none;
    
    &::placeholder {
      color: #555;
      font-size: 32px;
    }
  }
}

/* Confirm Button */
.confirm-btn {
  width: 100%;
  height: 100px;
  background: linear-gradient(to bottom, #a08873, #725842);
  border: none;
  border-radius: 12px;
  color: #4a2c1d;
  font-size: 36px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 20px;
  margin-bottom: 40px;
  transition: all 0.2s;
  
  &:active {
    opacity: 0.9;
    transform: translateY(2px);
  }
}

/* 说明 */
.shuoming {
  background: #242424;
  color: #999;
  padding: 40px;
  border-radius: 20px;
  margin: 0 40px 40px;
  border: 1px solid #333;
  
  .l_p {
    font-size: 26px;
    margin-top: 20px;
    line-height: 1.5;
    
    &.q1 {
      font-size: 30px;
      color: #e6b98a;
      margin-top: 0;
      margin-bottom: 30px;
      font-weight: bold;
      display: flex;
      align-items: center;
      
      .van-icon {
        margin-right: 10px;
        font-size: 36px;
      }
    }
  }
}
</style>
